import createEntity from "./createEntity.js";
import api from "../api.js";
import toast from "../toaster.js";
import youtubeApi from '../../module_user/api/youtube'

let trainerVideoList = createEntity({ namespaced: false });

const state = {
    videoDataLoading: false,
    videoId: null,
    scoringLogic: null,
    videoToEdit: null,
    s3Cred: null,
    deletingVideo: false,
    addingVideo: false,
    updatingVideo: false,
    categories:null,
    popularWorkouts: null,
    trendingWorkouts: null
};

const mutations = {
    update(state, changes) {
        Object.assign(state, changes);
    },
    setCategories(state, categories) {
        state.categories = categories;
    },
    setPopularWorkouts(state, popularWorkouts) {
        state.popularWorkouts = popularWorkouts;
    },
    setTrendingWorkouts(state, trendingWorkouts) {
        state.trendingWorkouts = trendingWorkouts;
    }
};

const getters = {
    trainerVideoList(state, getters, rootState, rootGetters) {
        return getters["trainerVideoList/getAll"];
    }

};

const actions = {
    async loadVideos(context) {

        context.commit("update", { videoDataLoading: true });

        let data = await api.getTrainerVideos();

        // Commenting till we have the fix for youtube Data API

        // let i;

        // for (i = 0; i < data.length; i++) {
        //     const stats = await youtubeApi.getYTStats(data[i].embedId);
        //     data[i].likes = stats ? stats.likeCount : 0
        // }
        context.commit("trainerVideoList/load", data);

        context.commit("update", { videoDataLoading: false });
    },

    async getCategories(context){
        const categories = await api.getCategories();
        context.commit('setCategories', categories);
        return categories;
    },

    async getPopularWorkouts(context) {
        const recommendations = await api.getPopularWorkouts();
        context.commit('setPopularWorkouts', recommendations);
        return recommendations;
    },
    async getTrendingWorkouts(context) {
        const recommendations = await api.getTrendingWorkouts();
        context.commit('setTrendingWorkouts', recommendations);
        return recommendations;
    },

    async deleteVideo(context, { vm, id }) {

        context.commit("update", { deletingVideo: true });

        await api.deleteVideo(id).then(() => {
            context.commit("trainerVideoList/delete", id);

            toast.showToasts(vm, 'Video Deleted Successfully', 'success');

        }).catch((error) =>
            toast.showToasts(vm, 'Deleting Video Failed.', 'danger')

        )
        context.commit("update", { deletingVideo: false });
    },

    async addVideo(context, { vm, data }) {
        context.commit("update", { addingVideo: true });

        const videoDuration = await youtubeApi.getVideoDuration(data.embedId);
        if (videoDuration.error) {
            toast.showToasts(vm, 'Please enter a valid YouTube video URL', 'danger');
        } else {
            data.duration = videoDuration.duration;

            await api.addVideo(data).then(async (response) => {

                data.id = response.id;
                data.uploadBy = context.rootState.userInfo.name;

                context.commit("trainerVideoList/add", data);

                //context.commit("trainerVideoList/load", await api.getVideos());

                toast.showToasts(vm, 'Video Added Successfully', 'success');


            }).catch((error) =>
                toast.showToasts(vm, 'Adding Video Failed', 'danger')
            )
        }
        context.commit("update", { addingVideo: false });
    },

    async updateVideo(context, { vm, data }) {
        context.commit("update", { updatingVideo: true });

        await api.updateVideo(data.id, data).then(() => {
            context.commit("trainerVideoList/update", data);

            toast.showToasts(vm, 'Video Updated Successfully', 'success');

        }).catch((error) => {
            toast.showToasts(vm, 'Updating Video Failed', 'danger')
        })
        context.commit("update", { updatingVideo: false });
    },

    async getS3Cred(context) {
        await api.getS3TempCred().then((response) => {
            context.commit("update", { s3Cred: response })
        })
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        trainerVideoList
    }
}